// @flow

import { IconButton } from "./icon-button";

export default IconButton;